import Button from "./Button";
import { BUTTON_VARIANT_TYPES } from "../../utils/constants"
import { useNavigate } from "react-router-dom";
import { DownloadIcon } from "@heroicons/react/solid";

function Notification(props) {
    const {
        title,
        message,
        primaryActionText,
        primaryActionLink,
        secondaryActionText,
        secondaryButton,
        type,
        icon,
        closeButton,
        buttonless
    } = props;

    const navigate = useNavigate();
    const goToLink = (link) => {
        navigate(link);
    }

    return (
        <div className={
            "grid grid-flow-row gap-2 w-full mx-auto rounded-md px-3 py-3 " +
            (type === "info" ? "bg-blue-100 text-blue-700" : "bg-red-100 text-red-700")
        }
        >
            <div className="flex flex-row items-center justify-between font-medium">
                {title}
                {
                    closeButton &&
                    <button type="button" className="float-right">
                        <svg className="mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                }
            </div>
            <p className="text-sm">
                {message}
            </p>

            {buttonless === false &&
                <div className="flex gap-2 mt-2">
                    {
                        type === "info" ?
                            <Button
                                text={primaryActionText}
                                iconPositionLeft
                                icon={icon && <DownloadIcon className={"block h-4 w-4 mr-1"} />}
                                onClick={() => goToLink(primaryActionLink)}
                                extraStyling={
                                    "text-white focus:ring-inset focus:ring-1 bg-primary-600 hover:bg-primary-700 " +
                                    "focus:outline-none focus:ring-primary-600 w-full text-center justify-center"
                                }
                            />
                            :
                            <Button
                                colour={BUTTON_VARIANT_TYPES.RED}
                                text={primaryActionText}
                            />
                    }
                    {
                        secondaryButton &&
                        <Button
                            colour={BUTTON_VARIANT_TYPES.GRAY}
                            text={secondaryActionText}
                        />
                    }
                </div>
            }
            
        </div>
    )
}

export default Notification;